/** @file Field check for one drawable: picks the shape by `kind`. */
import type { Drawable } from '@zilo/pose3d-format/types/drawable';
import { checkEnum } from '@zilo/pose3d-format/validate/fields/checkEnum';
import { expectShape } from '@zilo/pose3d-format/validate/fields/expectShape';
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';
import { DRAWABLE_SHAPES } from '@zilo/pose3d-format/validate/shapes/drawableShapes';

const kindCheck = checkEnum(Object.keys(DRAWABLE_SHAPES));

/** Check a drawable: an object whose `kind` is known, then that kind's shape. */
export const checkDrawable: FieldCheck = (value, path) => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) failField(path, 'object', value);
  const kind = (value as Record<string, unknown>).kind;
  kindCheck(kind, `${path}/kind`);
  expectShape(value, path, DRAWABLE_SHAPES[kind as Drawable['kind']]);
};
